import { ChannelSettings } from "../reducers/channelSettings";
import firebase from '../../lib/firebase'

export type CHANNEL_SETTINGS_ACTION_TYPES = ChangeValueAction | SaveLastVisitedAction;

export enum CHANNEL_SETTINGS_ACTIONS {
  CHANGE_SETTING = "CHANGE_CHANNEL_SETTING",
  SAVE_LAST_VISITED = "SAVE_LAST_VISITED"
}

export type ChangeValueAction = {
  type: CHANNEL_SETTINGS_ACTIONS.CHANGE_SETTING
  channelId: number
  property: keyof ChannelSettings
  value: any
}

export type SaveLastVisitedAction = {
  type: CHANNEL_SETTINGS_ACTIONS.SAVE_LAST_VISITED
  channelId: number
  centroidId?: number
  familyTag?: string
}

export const doChangeChannelSetting = ({channelId, property, value}: Omit<ChangeValueAction, "type">) => {
  // Firebase event
  firebase.analytics.logEvent("change_channel_setting", {channel_id: channelId, property, value});

  return {
    type: CHANNEL_SETTINGS_ACTIONS.CHANGE_SETTING,
    channelId,
    property,
    value
  }
}

export const doSaveLastChannel = (channelId: number, centroidId?: number, familyTag?: string) => {
  return {
    type: CHANNEL_SETTINGS_ACTIONS.SAVE_LAST_VISITED,
    channelId,
    centroidId,
    familyTag
  }
}
